import Dropdown from './src/dropdown'

export default Dropdown


// WEBPACK FOOTER //
// ./src/components/tofu-dropdown/index.js